import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';
import React from 'react';

import { useTranslator } from '@/hooks/useTranslator';
import { FiatAccount, SimplifiedAccount } from '@/types/contacts';

interface Props {
  readonly title: string;
  readonly accounts?: readonly FiatAccount[];

  onClick?(): void;
}

export const ContactItem: React.FC<Props> = (props: Props): React.ReactElement => {
  const { title, accounts = [], onClick } = props;

  const tr = useTranslator();
  const simplifiedAccounts = React.useMemo((): readonly SimplifiedAccount[] => {
    return accounts.map(FiatAccount.toSimplifiedAccount);
  }, [accounts]);

  return (
    <Box sx={[styles.container, onClick ? styles.clickable : null]} onClick={onClick}>
      <Typography variant="body2" color="text.primary">
        {title}
      </Typography>
      <Typography variant="body1" color="custom.LightGray">
        <Typography component="span" variant="inherit" color="inherit">
          {simplifiedAccounts
            .slice(0, 2)
            .map(
              (account: SimplifiedAccount): string => `${account.currency} | ${account.bankName}`,
            )
            .join(', ')}
        </Typography>
        {accounts.length > VISIBLE_ACCOUNTS_COUNT && (
          <Link color="inherit" component="span">
            <Typography variant="inherit" color="inherit" component="span">
              ,{' '}
            </Typography>
            <Typography variant="inherit" color="primary" component="span">
              {tr('MORE', accounts.length - VISIBLE_ACCOUNTS_COUNT)}
            </Typography>
          </Link>
        )}
      </Typography>
    </Box>
  );
};

const styles: Record<string, SystemStyleObject> = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: 'custom.DividerLight',
    borderRadius: 2,
    py: 3,
    px: 4,
  },
  clickable: {
    cursor: 'pointer',
  },
};

const VISIBLE_ACCOUNTS_COUNT = 2;
